// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3Q6Ov","validationTips":"StatementDescriptor_validationTips__3QrHX"};